module.exports = "img/21.fab8c3.webp";